import * as React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';

const Footer : React.FC = () => {
    const now = new Date().getFullYear();

    return (
        <footer>
        <div className={"footer"}>
            <Container fluid="md" className={"footer-content"}>
                <Row>
                    <Col lg={8} md={6}>
                        <div className={"site-map"}>サイトマップ</div>
                        <ul className={"site-map"}>
                            <li><a href={"/"}>宮岡クリニックトップページ</a></li>
                            <li><a href={"/intyou.html"}>医師紹介</a></li>
                            <li><a href={"/zion.html"}>ジオン注(痔核治療)</a></li>
                            <li><a href={"/lifestyle.html"}>生活習慣病</a></li>
                            <li><a href={"/gan.html"}>癌の早期発見</a></li>
                            <li><a href={"/setubi.html"}>設備案内</a></li>
                            <li><a href={"/access.html"}>アクセスマップ</a></li>
                        </ul>
                    </Col>
                    <Col lg={4} md={6} className={"logo"}>
                        <div className={"clinic-name"}>医療法人ゆうあい会</div>
                        <a href={"/"}><img src={"/images/miyaokaclinic.png"} alt={"医療法人ゆうあい会 宮岡クリニック　大阪市　港区 "}/></a>
                        <div className={"address"}>〒 552-0012 大阪市港区市岡1-14-16</div>
                        <div className={"tel"}>お問い合わせ: 06-6571-3506</div>
                    </Col>
                </Row>
                <Row>
                    <Col className={"copyright"}>
                        Copyright© 2006-{now} MIYAOKA CLINIC. All Rights Reserved.
                    </Col>
                </Row>
            </Container>
        </div>
        </footer>
    );
}

export default Footer;
